import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import { withPermission } from 'hoc';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const InventoryListDumb = ({
    handleSearch,
    searchValue,
    handleCreate,
    handleEdit,
    handleDelete,
    handleView,
    content,
    isLoaded,
    validPermission
}) => {
    const [t] = useTranslation();
    const methods = useForm();
    const onSubmit = (data) => {
        handleSearch(data);
    };

    const onDelete = (inventory) => {
        handleDelete(inventory);
    };

    const onEdit = (inventory) => {
        handleEdit(inventory);
    };
    const onView = (dataModel) => {
        handleView(dataModel);
    }

    const createActions = () => {
        const actions = [];

        
        if (validPermission(-1, 'isVisible'))
            actions.push({
                label: t('common.components.buttons.view'),
                icon: <VisibilityOutlinedIcon color="primary" />,
                handle: onView,
            });

        if (validPermission(-1, 'isEdit'))
            actions.push({
                label: t('inventoryList.components.table.edit'),
                icon: <EditOutlinedIcon color="primary" />,
                handle: onEdit,
            });
        
        if (validPermission(-1, 'isDelete'))
            actions.push({
                label: t('inventoryList.components.table.delete'),
                icon: <HighlightOffIcon color="primary" />,
                handle: onDelete,
            });

        return actions;
    }

    const columns = [
        { label: t('common.components.table.col.name'), key: 'name' },
        { label: t('common.components.table.col.description'), key: 'description' },
    ];

    const actions = createActions();

    return (
        <>
            <HeadlinePage
                title="inventoryList.headline"
                buttonLabel="inventoryList.components.add"
                handleOnClick={validPermission(-1, 'isCreate')?handleCreate:null}
            />

            <SearchBarBox
                onSubmit={onSubmit}
                methods={methods}
                hideProject={true}
                searchValue={searchValue}
            />

            <Paper sx={{ p: 2 }}>
                <TableCustom
                    title="inventoryList.components.titleList"
                    columns={columns}
                    content={content}
                    actions={actions}
                    loading={isLoaded}
                    handleNotResults={handleCreate}
                />
            </Paper>
        </>
    )
}

export default withPermission(InventoryListDumb, "inventories");
